// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c10510e","453":"5b098dc1","455":"9bc0b4a7","977":"a728338a"}[chunkId] + ".chunk.js";
};